exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "canvas[data-v-2b41f59e]{max-height:300px}", ""]);

// exports
